// src/unicodex_ui/services/authApi.js
import api from "./apiClient";

/**
 * Manufacturer (and other non-admin) login.
 * POST /api/auth/login
 *
 * @param {string} email
 * @param {string} password
 * @returns {Promise<{ ok: boolean, token?: string, user?: object }>}
 */
export async function login(email, password) {
  const res = await api.post("/api/auth/login", { email, password });
  const data = res.data; // { ok, token, user }
  if (data?.ok && data?.token) {
    // Immediately hydrate permissions from backend (source of truth)
    try {
      localStorage.setItem("ucx_mfg_token", data.token);
      const me = await getMe(); // { ok, user, permissions }
      if (me?.ok) {
        storePortalSession({ token: data.token, user: me.user, permissions: me.permissions });
        return { ...data, user: me.user, permissions: me.permissions };
      }
    } catch {
      // fall back to storing token+user only
      storePortalSession({ token: data.token, user: data.user, permissions: [] });
    }
  }
  return data;
}

export async function getMe() {
  const res = await api.get("/api/auth/me");
  return res.data; // { ok, user, permissions }
}

export function storePortalSession({ token, user, permissions }) {
  if (token) localStorage.setItem("ucx_mfg_token", token);
  if (user) localStorage.setItem("ucx_mfg_user", JSON.stringify(user));
  if (Array.isArray(permissions)) localStorage.setItem("ucx_permissions", JSON.stringify(permissions));
}

export function clearPortalSession() {
  localStorage.removeItem("ucx_mfg_token");
  localStorage.removeItem("ucx_mfg_user");
  localStorage.removeItem("ucx_permissions");
}

export function getStoredPortalUser() {
  try {
    const raw = localStorage.getItem("ucx_mfg_user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function getStoredPermissions() {
  try {
    const raw = localStorage.getItem("ucx_permissions");
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}
